import styled from "@emotion/styled";
import { RequiredThemeKeys } from "../../../../util/theme";
import { Button } from "../../../button";
import { datePickerTheme } from "./datePickerTheme";

interface DatePickerMonthSwitchButtonProps {
    themeMode: RequiredThemeKeys;
}

export const DatePickerMonthSwitchButton = styled(Button)<DatePickerMonthSwitchButtonProps>`
    height: 32px;
    width: 32px;

    // A secondary Button's text color, when enabled, would normally be a blueish color, but we want
    // it to be our standard font color. If the button is disabled, we want to keep the color the
    // same as the disabled color the button already uses.
    &:not([aria-disabled="true"]) {
        color: ${({ themeMode }) => datePickerTheme.color(themeMode)};
    }

    // This ensures the button focus outlines always show above their neighbors.
    z-index: 0;
    &:focus {
        z-index: 1;
    }
`;
